/** Fully Qualified Domain Name (FQDN) that extends the built-in URL class, adding the subdomain as a property */
export default class FQDN extends URL {
    subdomain;
    constructor(url = window.location.href) {
        super(url);
        this.subdomain = this.getSubdomain();
    }
    /** Extracts the subdomain from the URL */
    getSubdomain() {
        const parts = this.hostname.split('.');
        return parts.length > 2 ? parts.slice(0, -2).join('.') : '';
    }
}
